import { Button } from "primereact/button";
import { TreeSelect, TreeSelectExpandedEvent } from "primereact/treeselect";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { analyticsObjectCategories, analyticsObjects } from "./analyticsObjects";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";

interface TreeNode {
    key: string;
    label: string;
    data?: string;
    icon?: JSX.Element | string;
    children?: any;
}

// Компонент - выбор типов объектов для составления отчета
export function AnalyticsObjectsChoose() {
    const navigate = useNavigate()

    const [selectedNodeKeys, setSelectedNodeKeys] = useState<any>()
    const [expandedKeys, setExpandedKeys] = useState<any>({});

    // получение списка типов объектов и категорий из локлаьного состония
    const objectTypesStructure = getItemWebStorage("objectTypesStructure")

    // функция для составления узлов дерева выбора требующихся типов объектов для составления отчета
    function createTreeNodes(data: any[], parentKey: string = '') {
        let count = -1
        return data.map((item) => {
            count++
            // при наличии типа объекта из общего списка в списке типов объектов для аналитики добавляем его в дерево
            if (analyticsObjects[item.Caption] || item.Caption in analyticsObjectCategories) {
                const key = parentKey ? `${parentKey}-${count}` : `${count}`;
                const treeNode: TreeNode = {
                    key: key,
                    label: item.Caption,
                    data: item.Caption,
                    icon: (item?.ImageIndex + '').length === 3 ? `icon-0${item?.ImageIndex}` : `icon-${item?.ImageIndex}`,
                    children: item?.Types ? createTreeNodes(item?.Types, key) : null
                };
                return treeNode;
            } else {
                count--
                return null
            }
        }).filter(item => item !== null);
    }

    // определение узлов для дерева выбора типов объектов
    const treeNodes = objectTypesStructure && createTreeNodes(objectTypesStructure);

    // обработка выбора типа объекта в дереве
    function treeSelectChange(event: any) {
        setSelectedNodeKeys(event.value)
        noCloseMulti(event)
    }

    function noCloseMulti(event: any) {
        event.originalEvent.stopPropagation();
    }

    // функция для получения названий для Chip-блоков
    function getNameValues() {
        let result: any = []
        let chips = document.getElementsByClassName('p-treeselect-token-label')
        Object.values(chips).map(item => {
            if (item) {
                if (analyticsObjects[item.innerHTML]) {
                    result.push(item.innerHTML)
                }
            }
        })
        return result
    }

    // функция для раскрытия всех узлов дерева
    function expandAll() {
        let _expandedKeys = {};

        for (let node of treeNodes) {
            expandNode(node, _expandedKeys);
        }

        setExpandedKeys(_expandedKeys);
    }

    // функция для закрытия всех узлов
    function collapseAll() {
        setExpandedKeys({});
    }

    // функция для раскрытия узла
    function expandNode(node: any, _expandedKeys: any) {
        if (node.children && node.children.length) {
            _expandedKeys[node.key] = true;

            for (let child of node.children) {
                expandNode(child, _expandedKeys);
            }
        }
    }

    // обработчик для кнопки подтверждения выбора типов объектов
    function sumbitReport() {
        setItemWebStorage('analytics', { 'chosenObjects': getNameValues() })
        navigate('/app/analytics')
    }

    // Шаблон шапки, которая содержит кнопки раскрытия и закрытия всех узлов
    const headerTemplate = (
        <div className="p-3 border">
            <Button type="button" icon="pi pi-plus" onClick={expandAll} className="p-button-outlined me-2 expand-nodes-button" />
            <Button type="button" icon="pi pi-minus" onClick={collapseAll} className="p-button-outlined hide-nodes-button" />
        </div>
    );
    return (
        <div>
            {objectTypesStructure &&
                <div className="analytics-choose-div">
                    {/* Кнопка подтверждения выбора типов объектов */}
                    <div className="button-div">
                        <Button label="Составить отчет" severity="success" className="submit-report-btn" onClick={sumbitReport} disabled={(selectedNodeKeys && Object.keys(selectedNodeKeys)?.length == 0) || !selectedNodeKeys} />
                    </div>
                    <div >
                        <TreeSelect
                            autoFocus
                            filter
                            options={treeNodes}
                            metaKeySelection={false}
                            className="object-types-multiselect mt-3"
                            scrollHeight="800px"
                            selectionMode="checkbox"
                            display="chip"
                            placeholder="Выбрать объекты для составления отчёта"
                            value={selectedNodeKeys}
                            onChange={(e) => treeSelectChange(e)}
                            expandedKeys={expandedKeys}
                            onToggle={(e: TreeSelectExpandedEvent) => setExpandedKeys(e.value)}
                            panelFooterTemplate={headerTemplate}
                        >
                        </TreeSelect>
                    </div>
                </div>
            }
        </div>
    );
}

